<div class="chat-wrapper">
  <button class="chat-icon" [class.active]="isChatOpen" (click)="toggleChat()" aria-label="Toggle chat">
    <img [src]="chatIcon" alt="Accesso Chat" class="chat-logo" />
  </button>

  @if (isChatOpen) {
    <div class="chat-window">
      <div class="chat-header">
        <div class="header-content">
          <img [src]="chatIcon" alt="Accesso" class="header-logo" />
          <h3>Developer Assistant</h3>
        </div>
        <button class="close-btn" (click)="toggleChat()">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <div class="chat-messages" #scrollMe>
        @for (message of messages; track message.id) {
          <div class="message" [class.user-message]="message.isUser" [class.loading]="message.loading">
            <span class="message-content">
              @if (message.loading) {
                <i class="pi pi-spin pi-spinner"></i> Thinking...
              } @else {
                {{ message.text }}
              }
            </span>
          </div>
        }
      </div>

      <div class="chat-input">
        <ud-input
          #messageInput
          [(ngModel)]="currentMessage"
          (keyup.enter)="sendMessage()"
          placeholder="Type a message..."
          [label]="'Message'"
          [disabled]="isWaiting"
        >
        </ud-input>
        <ud-button [variant]="'text'" [icon]="'pi pi-send'" (onClick)="sendMessage()" [disabled]="!currentMessage.trim() || isWaiting"> </ud-button>
      </div>
    </div>
  }
</div>
